import { useState } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import IconButton from "../../iconButton";
import { PlusCircleIcon } from "@heroicons/react/24/outline";
import DashboardCalendarSlideOver from "./slideovers/DashboardCalendarSlideOver";

function classNames(...classes) {
  return classes.filter(Boolean).join(" ");
}

const DashboardCalendar = () => {
  const [showCalendarSlideOver, setShowCalendarSlideOver] = useState(false);

  const handleClose = () => {
    setShowCalendarSlideOver(false);
  };

  return (
    <div>
      <div className="calender-wrapper">
        <Calendar className="mb-5" />
      </div>
      <div>
        <h6 className="text-sm font-bold leading-[160%] text-[#485868] mb-[10px]">
          Events
        </h6>
        <ul className="scroller mb-5 max-h-[155px] overflow-y-auto pr-3">
          <li className="py-[14px] px-3 border-b border-[#EBEFF3] flex items-center justify-between">
            <div className="flex items-center gap-3.5">
              <div className="w-[6px] h-[6px] rounded-[50%] bg-black"></div>
              <h6 className="text-sm font-bold leading-[160%] text-customGray">
                Zoom Call
              </h6>
            </div>
            <span className="text-sm font-medium leading-[160%] text-customGray uppercase inline-block">
              XX:XX AM
            </span>
          </li>
          <li className="py-[14px] px-3 border-b border-[#EBEFF3] flex items-center justify-between">
            <div className="flex items-center gap-3.5">
              <div className="w-[6px] h-[6px] rounded-[50%] bg-black"></div>
              <h6 className="text-sm font-bold leading-[160%] text-customGray">
                Work Report
              </h6>
            </div>
            <span className="text-sm font-medium leading-[160%] text-customGray uppercase inline-block">
              XX:XX AM
            </span>
          </li>
          <li className="py-[14px] px-3 border-b border-[#EBEFF3] flex items-center justify-between">
            <div className="flex items-center gap-3.5">
              <div className="w-[6px] h-[6px] rounded-[50%] bg-black"></div>
              <h6 className="text-sm font-bold leading-[160%] text-customGray">
                Planning Meeting
              </h6>
            </div>
            <span className="text-sm font-medium leading-[160%] text-customGray uppercase inline-block">
              XX:XX AM
            </span>
          </li>
          <li className="py-[14px] px-3 border-b border-[#EBEFF3] flex items-center justify-between">
            <div className="flex items-center gap-3.5">
              <div className="w-[6px] h-[6px] rounded-[50%] bg-black"></div>
              <h6 className="text-sm font-bold leading-[160%] text-customGray">
                Zoom Call
              </h6>
            </div>
            <span className="text-sm font-medium leading-[160%] text-customGray uppercase inline-block">
              XX:XX AM
            </span>
          </li>
        </ul>
      </div>
      <IconButton
        title="add new event"
        icon={PlusCircleIcon}
        classes="flex items-center bg-primary text-sm text-white rounded-[10px] font-black uppercase text-[#485868] leading-[160%] h-10 w-full justify-center cursor-pointer mb-3"
        onClick={() => setShowCalendarSlideOver(true)}
        iconClasses="icon w-6 h-6 -ml-0.5 mr-[10px]"
      />
      <DashboardCalendarSlideOver
        show={showCalendarSlideOver}
        setShowSlide={setShowCalendarSlideOver}
        handleClose={handleClose}
        // handleSuccess={handleSuccess}
      />
    </div>
  );
};

export default DashboardCalendar;
